import React, { useEffect, useState } from 'react';
import {
  TextField,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

import useAdminRequest from '../../../requests/AdminRequest';

import Paginator from '../../common/Paginator';
import Loader from '../../common/Loader';

const Messages = (props) => {
  const { batch, onDetails, date } = props;

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [to, setTo] = useState('');
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const { getTraceMessages } = useAdminRequest();

  const refresh = async () => {
    setLoading(true);
    try {
      const data = await getTraceMessages(
        batch.customer_user_id,
        date,
        to,
        page,
        props.errorHandler
      );
      setData(data.items);
      setTotal(data.total);
    } catch (error) {
      console.error('Error fetching trace messages:', error);
    } finally {
      setLoading(false);
    }
  };

  const messageDetails = (email, message) => {
    const item = { ...email, messages: [message] };
    onDetails(item);
  };

  const pageChange = (page) => {
    setPage(page);
  };

  let timer;
  const filterUpdate = (value) => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      setTo(value);
      setPage(1);
    }, 350);
  };

  useEffect(() => {
    refresh();
  }, [batch, to, page]);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: 2,
        }}
      >
        <Box>
          <Typography>
            <strong>Sent By:</strong> {batch.customer_user_name} of{' '}
            {batch.customer_name}
          </Typography>
          <Typography>
            <strong>Last Updated:</strong>{' '}
            {new Intl.DateTimeFormat('en-us', {
              year: 'numeric',
              month: 'short',
              day: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
              second: 'numeric',
            }).format(new Date(batch.last_updated))}
          </Typography>
        </Box>

        <TextField
          type="text"
          label="To"
          variant="outlined"
          value={to}
          size="small"
          onChange={(e) => {
            filterUpdate(e.target.value);
          }}
        />
      </Box>

      <TableContainer sx={{ marginBottom: 4, overflowX: 'auto' }}>
        <Table size="small" sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow>
              <TableCell>Date</TableCell>
              <TableCell>IP</TableCell>
              <TableCell>From</TableCell>
              <TableCell>To</TableCell>
              <TableCell>Result</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading && (
              <TableRow>
                <TableCell colSpan={5}>
                  <Loader />
                </TableCell>
              </TableRow>
            )}
            {data.map((message, k) => (
              <TableRow key={k} onClick={() => messageDetails(message)} hover>
                <TableCell>
                  {new Intl.DateTimeFormat('en-us', {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                    second: 'numeric',
                  }).format(new Date(message.last_updated))}
                </TableCell>
                <TableCell>{message.ipAddress}</TableCell>
                <TableCell>{message.origin}</TableCell>
                <TableCell>{message.destination}</TableCell>
                <TableCell>
                  {message.error ? (
                    <Typography className="text-danger">Error</Typography>
                  ) : (
                    <Typography className="text-success">Success</Typography>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {total > 10 && (
        <Paginator
          itemCount={total}
          pageNumber={page}
          changeEvent={(page) => {
            pageChange(page);
          }}
        />
      )}
    </>
  );
};

export default Messages;
